export default {
	about: 'Sobre',
	about_the_program: 'Sobre o Programa',
	acc_score: 'Ponto acumulado | Pontos acumulados',
	accept: 'Aceitar',
	activities: 'Atividades',
	activity: 'Atividade',
	add_a_review: 'Adicione uma avaliação',
	add_image: 'Adicionar imagem',
	address: 'Endereço',
	address_required: 'Endereço é obrigatório',
	all: 'Todos',
	all_f: 'Todas',
	an_error_has_occurred: 'Ocorreu um erro',
	an_unexpected_error_has_occurred_try_again: 'Ocorreu um erro inesperado. Tente novamente.',
	and: 'e',
	answer: 'Resposta',
	answer_plural: 'Respostas',
	answer_reported_successfully: 'Resposta reportada com sucesso',
	answered: 'Respondido',
	apply: 'Aplicar',
	approved: 'Aprovado',
	areas: 'Áreas',
	at: 'às',
	attention: 'Atenção',
	audio: 'Audio',
	available_in: 'Disponível em',
	back: 'Voltar',
	back_to_training: 'Voltar para o treinamento',
	badge: 'Medalha | Medalhas',
	badges: 'Medalhas',
	before_starting_this: ' antes de iniciar esse',
	bookmarks: 'Favoritos',
	browser_window_blocked_click: 'Seu navegador bloqueou a janela, por favor clique',
	by: 'por',
	calendar: 'Agenda',
	campaign: 'Campanha',
	campaigns: 'Campanhas',
	cancel: 'Cancelar',
	cant_watch_click_here: 'Clique aqui para assistir em tela cheia',
	categories: 'Categorias',
	category: 'Área de Treinamento',
	certificate: 'Certificado | Certificados',
	certificates: 'Certificados',
	check_scorm_finished: 'Verificar finalização da atividade',
	clear_date: 'Limpar data',
	clear_filters: 'Limpar filtros',
	clear_notifications: 'Limpar notificações',
	click_here: 'Clique aqui.',
	close: 'Fechar',
	code: 'Código',
	code_a_z: 'Código A-Z',
	compressed_file: 'Arquivo Comprimido',
	confirm: 'Confirmar',
	confirm_report_answer: 'Confirme reporte da resposta',
	confirm_report_topic: 'Confirme reporte do tópico',
	confirm_reporting_this_answer_this_should_be_done_only_with_answers_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirma reportar essa resposta? Isso deve ser feito apenas com respostas que não seguem as regras da plataforma. Uma mensagem será enviada aos moderadores',
	confirm_reporting_this_topic_this_should_be_done_only_with_topics_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirma reportar esse tópico? Isso deve ser feito apenas com tópicos que não seguem as regras da plataforma. Uma mensagem será enviada aos moderadores',
	contact_us: 'Contato',
	content: 'Conteúdo | Conteúdos',
	content_deadline: 'Data limite para acesso ao conteúdo',
	cookies_custom: 'Cookies personalizado',
	cookies_custom_information:
		'Quando você acessa esta plataforma, poderão ser coletados cookies e alguns dados relacionados ao seu dispositivo, a fim de que possamos fornecer conteúdos e treinamentos personalizados para você.',
	cookies_fonctionnels: 'Cookies funcionais',
	cookies_fonctionnels_information:
		'São usados para te reconhecer quando acessar a plataforma, salvar suas preferências de configuração e proteger seu usuário. Não podem ser desativados porque são essenciais para o funcionamento da plataforma.',
	cookies_policy: 'Política de Cookies',
	cookies_policy_information:
		'Esta plataforma utiliza os cookies para garantir um serviço mais eficiente e personalizado. Ao aceitar, você concordará com a utilização deles.',
	cookies_settings: 'Configurações de Cookies',
	copyright: 'Copyright',
	correct: 'Corretas',
	country_of_residence: 'País de residência',
	country_you_want_to_access: 'País que deseja acessar',
	course: 'Curso',
	course_price: 'Valor',
	creation_date: 'Data de criação',
	creator: 'Criador',
	crop: 'Recortar',
	crop_image: 'Recortar imagem',
	date: 'Data',
	description: 'Descrição',
	divorced: 'Divorciado(a)',
	document: 'Documento',
	done: 'Concluído',
	doubts_about_training: 'Dúvidas sobre o treinamento',
	download: 'Download',
	share: 'Compartilhar',
	copy_link: 'Copiar link',
	link_copied_to_clipboard: 'Link copiado para área de transferência',
	unable_to_copy_automatically: 'Não foi possível copiar automaticamente',
	download_app: 'Baixar aplicativo',
	download_our_app: 'Baixe nosso aplicativo',
	download_our_app_information:
		'Você já conhece nosso aplicativo? Aproveite todo nosso conteúdo também do seu iPhone ou Android. Baixe já, é de graça!',
	downloading_content: 'Baixando conteúdo',
	downloads: 'Downloads',
	duration: 'Duração',
	earn_points: 'Ganhe Pontos',
	earned: 'Adquiridos',
	earning_points: 'Ganho de pontos',
	email: 'Email',
	enter: 'Acessar',
	error_loading_data: 'Ocorreu um erro ao carregar as informações. Tente mais tarde.',
	events: 'Meus Eventos',
	excel_file: 'Arquivo Excel',
	extensions: 'Extensões',
	faq: 'FAQ',
	favorite_course: 'Favoritar Curso',
	favorite_trail: 'Favoritar Trilha',
	featured_rewards: 'Prêmios em Destaque',
	file: 'Arquivo',
	file_download_failed: 'Download do arquivo falhou',
	file_download_finished: 'Download do arquivo finalizado',
	file_download_started: 'Download do arquivo iniciado',
	filters: 'Filtros',
	filter_category: 'Filtrar por categoria',
	filter_sort_by: 'Ordenar por',
	finished: 'Finalizados',
	first_access: 'Primeiro Acesso',
	follower: 'Seguidor',
	free: 'grátis',
	frequently_asked_questions: 'Perguntas Frequentes',
	full_name: 'Nome completo',
	go_to_class: 'Ir para a aula',
	groups: 'Grupos',
	have_any_doubt_sugestion_comment_or_compliment_about_the_intel_rewards_you_program_send_us_a_message:
		'Tem alguma dúvida, sugestão ou comentário sobre o programa Intel Te Premia? Envie-nos uma mensagem.',
	headquarter: 'Rede / Empresa',
	headquarters: 'Redes / Empresas',
	help: 'Ajuda',
	helper_new_password: 'Sua senha deve conter no mínimo 6 caracteres',
	helper_password_low: 'Sua senha deve conter no mínimo 6 caracteres',
	helper_password_medium:
		'Sua senha deve conter no mínimo 6 caracteres, letras maiúsculas, letras minúsculas, números',
	helper_password_strong:
		'Sua senha deve conter no mínimo 6 caracteres, letras maiúsculas, letras minúsculas, números e símbolos  (!@#$%ˆ)',
	here: 'aqui',
	home: 'Início',
	hour: 'hora',
	hour_plural: 'horas',
	how_do_you_rate_this_training: 'Como você avalia este treinamento?',
	image: 'Imagem',
	image_from_device: 'Imagem do dispositivo',
	image_from_url: 'Imagem de endereço',
	image_size: 'Tamanho da imagem',
	image_url: 'Endereço da imagem',
	in_progress: 'Em andamento',
	influencer: 'Influencer',
	insert_sales: 'Inserir Vendas',
	instructors: 'Instrutores',
	intel_lovers: 'Intel Lovers',
	introduction: 'Introdução',
	invalid_document: 'Documento inválido',
	invited: 'Convidado',
	items_per_page: 'Itens por página',
	itp_points: 'Pontos ',
	joined_the_class: 'entrou na aula',
	keep_watching: 'Continue assistindo',
	know_more: 'Sobre',
	language: 'Idioma',
	last: 'Mais recente',
	last_name: 'Sobrenome',
	legal_information: 'Informações Legais',
	lets_talk_about_privacy: 'Vamos falar sobre privacidade!',
	level: 'Nível',
	library: 'Biblioteca',
	like: 'Curtir',
	liked: 'Curtida',
	likes: 'Curtidas',
	live_class: 'Aula ao Vivo',
	live_classes: 'Aulas ao Vivo',
	loading_data: 'Carregando dados',
	loading_news: 'Carregando notícias',
	make_sure_all_mandatory_fields_are_completed:
		'Certifique-se de que todos os campos obrigatórios estão preenchidos',
	make_sure_that_all_fields_are_filled_in: 'Certifique-se que todos os campos estão preenchidos',
	married: 'Casado(a)',
	meet_the_team: 'Conheça o Time',
	message: 'Mensagem',
	message_sent_successfully: 'Mensagem enviada com sucesso',
	minute: 'minuto',
	minute_plural: 'minutos',
	name: 'Nome',
	new_certificate_in_course: 'Novo certificado no curso {title}',
	new_certificate_in_trail: 'Novo certificado na trilha {title}',
	new_download_code: 'Gerar novo código de Download',
	news: 'Notícias',
	next_activity: 'Próxima atividade',
	no: 'Não',
	no_data_avaliable: 'Sem dados disponíveis',
	no_news_are_available_at_the_moment: 'Sem notícias no momento.',
	no_news_are_available_with_the_selected_filter:
		'Não existem notícias disponíveis para o filtro selecionado',
	no_pre_visualization_available: 'Não há pré-visualização disponível',
	no_results: 'Nenhum resultado',
	no_results_found: 'Nenhum resultado encontrado',
	no_vacancy: 'Vagas esgotadas',
	not_allowed_or_page_not_found: 'Não encontrado ou não possui permissão para acessar.',
	not_answered: 'Não respondido',
	not_answered_f: 'Não respondida',
	notification: 'Notificação',
	notifications: 'Notificações',
	number_required: 'Número é obrigatório',
	neighborhood_required: 'Bairro é obrigatório',
	state_required: 'Estado é obrigatório',
	city_required: 'Cidade é obrigatório',
	zip_code_required: 'CEP é obrigatório',
	complete_your_registration: 'Complete seu cadastro',
	select_your_profile: 'Selecione seu perfil',
	fill_in_later: 'Preencher depois',
	document_required: 'CPF é obrigatório',
	document_already_registered: 'CPF já cadastrado',
	no_registered_profile: 'Sem perfil cadastrado. Verifique com o gestor da plataforma para liberar corretamente a autenticação.',
	login_with_google: 'Login com google',
	error_signing_in_with_google: 'Erro ao efetuar login com o Google, tente novamente mais tarde.',
	birthday_must_be_before_today: 'Preencha o campo corretamente',
	please_fill_out_the_form_correctly:
		'Por favor, preencha o formulário corretamente. Verifique se todos os campos obrigatórios foram preenchidos.',
	your_accounts_has_been_completed_successfully:
		'Sua conta foi completada com sucesso. Você será redirecionado.',
	register_not_unique: 'Registro não único',
	of: 'de',
	online_courses: 'Cursos Online',
	only_available_when_finished_training: 'Disponível somente após a conclusão do treinamento',
	order_by: 'Ordenar por',
	origin: 'Origem',
	password: 'Senha',
	pdf_file: 'Arquivo PDF',
	percentage: 'Porcentagem',
	place: 'Lugar',
	platform_meta_description:
		'Programas profissionais de treinamento abrangentes, que agregam valor, tendo como foco central a satisfação do cliente, cumprindo assim os objetivos de negócios.',
	please_wait_activities_loading: 'Carregando atividades, aguarde...',
	podcasts: 'Podcasts',
	point: 'Ponto | Pontos',
	point_plural: 'Pontos',
	points: 'Pontos',
	points_earned: 'Pontos Ganhos',
	points_table: 'Tabela de Pontos',
	pontuation: 'Pontuação',
	post_a_comment: 'Enviar um comentário',
	powerpoint_file: 'Arquivo PowerPoint',
	presential: 'Presencial',
	presential_courses: 'Cursos Presenciais',
	privacy_policy: 'Política de Privacidade',
	price: 'Preço',
	profile: 'Perfil',
	progress: 'Progresso',
	ranking: 'Ranking',
	reaction_evaluation: 'Avaliação de Reação',
	received_a_certificate_in_course: '{name} recebeu um certificado no curso {title}',
	received_a_certificate_in_trail: '{name} recebeu um certificado na trilha {title}',
	"physical-product": 'Produto Físico',
	"voucher": 'Voucher',
	redemption_code: 'Código de resgate',
	refuse: 'Recusar',
	regionals: 'Regionais',
	registered: 'Matriculado',
	reproved: 'Reprovado',
	requirement: 'Requisito',
	response_sent_successfully: 'Resposta enviada com sucesso',
	result_found: 'resultado encontrado | resultados encontrados',
	retry_test: 'Tentar novamente',
	return_to_activities: 'Retornar as atividades',
	reviews: 'Avaliações',
	reward_store: 'Loja de Recompensas',
	rewards_you: 'Te Premia',
	reward_redemption: 'Resgate de recompensa',
	rotate_device_for_better_experience: 'Vire o dispositivo para melhor experiência!',
	save: 'Gravar',
	save_data_success: 'Dados gravados com sucesso!',
	score: 'Pontuação',
	score_statement: 'Extrato da Pontuação',
	scorm_finished: 'Atividade finalizada',
	scorm_not_finished: 'Atividade não finalizada',
	search: 'Pesquisar',
	search_for_your_address: 'Busque pelo seu endereço',
	search_for_zip_address_or_city: 'Busque por seu endereço ou CEP',
	see_all_content: 'Acessar todo o conteúdo',
	see_more: 'Ver mais',
	select_a_file: 'Selecione um arquivo',
	select_a_image: 'Selecione uma imagem',
	selected_campaign: 'Campanha Selecionada',
	seller_cant_find_your_store:
		'Lojista, pesquise a sua loja digitando apenas o número do CNPJ (sem utilizar pontos, traços e barras). Não encontrou a sua loja?',
	seller_hint:
		'Pesquise a sua loja digitando apenas o número do CNPJ (sem utilizar pontos, traços e barras).',
	send: 'Enviar',
	set_cookies: 'Configurar cookies',
	show_certificate: 'Exibir certificado',
	single: 'Solteiro(a)',
	size: 'Tamanho',
	start_reaction_assessment: 'Iniciar Avaliação de Reação',
	status: 'Status',
	support: 'Suporte',
	tags: 'Destaques',
	take_course: 'Fazer Curso',
	terms_and_conditions: 'Termos e Condições',
	test: 'Prova',
	there_are_no_codes_available:
		'Não há códigos disponíveis para liberar aplicativo na App Store. Favor entrar em contato com o suporte.',
	this_content_will_be_available_on: 'Esse conteúdo estará disponível em',
	this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox:
		'Este site é melhor visualizado no Google Chrome e Mozilla Firefox.',
	timezone: 'Fuso-horário',
	title: 'Título',
	title_a_z: 'Título A-Z',
	to_access_the_class: 'para acessar a aula.',
	to_do: 'A fazer',
	to_understand_why_we_use_cookies: 'Para mais informações clique aqui.',
	total_results: 'Total de resultados',
	topic_reported_successfully: 'Tópico reportado com sucesso',
	trail: 'Trilha',
	trail_plural: 'Trilhas',
	trails: 'Trilhas',
	training: 'Treinamento',
	training_plural: 'Treinamentos',
	type: 'Tipo',
	type_to_search: 'Digite para buscar',
	unfavorite_course: 'Desfavoritar Curso',
	unfavorite_trail: 'Desfavoritar Trilha',
	unlike: 'Descurtir',
	upload_photos: 'Enviar Fotos',
	user: 'Usuário',
	user_environment: 'Ambiente do usuário',
	vimeo: 'Vimeo',
	we_were_unable_to_send_your_message_please_try_again_later:
		'Não foi possível enviar sua mensagem, tente novamente mais tarde',
	webcast: 'Webinar',
	webcasts: 'Webinars',
	webinar: 'Webinar',
	webinars: 'Webinars',
	widowed: 'Viúvo(a)',
	window_blocked: 'Janela bloqueada',
	workload: 'Carga horária',
	wowza: 'Wowza',
	yes: 'Sim',
	you_already_reviewed: 'Você já adicionou uma avaliação',
	you_must_complete_all_required_training_before_redeeming:
		'Você precisa completar todos os treinamentos obrigatórios antes de efetuar um resgate',
	you_must_finish_the_test: 'Por favor, finalize a prova',
	you_need_to_end_the_training_before_you_can_respond_to_the_reaction_assessment:
		'Você precisa finalizar as atividades antes de responder a avaliação de reação',
	you_need_to_finish_the_content: 'Você precisa finalizar o conteúdo ',
	your_answer: 'Sua resposta',
	your_rating: 'Sua avaliação',
	your_text_is_longer_than_256_characters: 'Seu texto tem mais que 256 caracteres',
	youtube: 'YouTube',
	zip_code: 'CEP',
	zip_code_required: 'CEP é obrigatório',
	oldest: 'Mais antigo',
	correct_answer: 'Questão correta',
	incorrect_answer: 'Questão incorreta',
	drills: 'Drills',
	badge_title_shared: 'Confira a nova medalha que ganhei',
	badge_title_earned: 'Parabéns, você ganhou uma nova medalha!',
	badge_button_text_claim: 'Aceitar medalha',
	challenge_of_the_day: 'Desafio do dia',
	recall_and_test_your_knowledge_with_quick_questions: 'Relembre e teste seu conhecimento com {count} pergunta rápida | Relembre e teste seu conhecimento com {count} perguntas rápidas',
	correct_answer: 'Resposta correta',
	incorrect_answer: 'Resposta incorreta',
	can_you_answer_this_question: 'você consegue responder essa pergunta?',
	unavailable: 'Indisponível',
	you_already_have_a_certificate_in_one_event_on_this_catalog: 'Você já está inscrito ou possui um certificado em um evento desse catalogo {catalog}.',
	no_category: 'Sem categoria',
	no_access_to_send_points: "Infelizmente você não tem acesso para enviar pontos, entre em contato com o administrador da plataforma.",
	search_by_ia: 'Pesquise por IA',
	please_log_in_to_the_platform_first: "Para baixar o aplicativo, realize primeiro o login na plataforma",
	required_update_title: 'Atualização Obrigatória',
	required_update_message_ios: 'Uma nova versão do aplicativo está disponível com melhorias essenciais. Para continuar, atualize manualmente seguindo estes passos:<br><br><b>1.</b> Abra o aplicativo da <b>App Store</b>.<br><b>2.</b> Toque no ícone do seu perfil (canto superior direito).<br><b>3.</b> Role a tela para baixo até a seção de atualizações pendentes e toque em <b>Atualizar</b> ao lado do nosso aplicativo.',
	required_update_message_android: 'Uma nova versão do aplicativo está disponível com melhorias essenciais. Para continuar utilizando a plataforma, clique no botão abaixo para ser redirecionado à loja de aplicativos e concluir a atualização de forma automática.',
	required_update_button_android: 'Atualizar'
}
